module.exports = __webpack_public_path__ + "img/m6.d15f79b3.jpg";